import * as types from 'model/actionTypes'
import { DictT, UserProfileT } from 'shared/types/model'

export function receiveUsersProfiles (profiles: DictT<UserProfileT>) {
  return {
    type: types.RECEIVE_USERS_PROFILES,
    profiles
  }
}
